import { Component } from '@angular/core';

@Component({
  selector: 'app-overview-section-row',
  templateUrl: './overview-section-row.component.html',
  styleUrls: ['./overview-section-row.component.scss'],
})
export class OverviewSectionRowComponent {}
